module.exports = __webpack_public_path__ + "static/media/icon-plant.5fff578f.svg";